import { render, staticRenderFns } from "./SwiftPayments.vue?vue&type=template&id=77a67388&scoped=true"
import script from "./SwiftPayments.vue?vue&type=script&lang=js"
export * from "./SwiftPayments.vue?vue&type=script&lang=js"
import style0 from "./SwiftPayments.vue?vue&type=style&index=0&id=77a67388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a67388",
  null
  
)

export default component.exports